<script setup lang="ts">
import DolphinTextInput from '@/components/atoms/DolphinTextInput.vue'
import FlatButton from '@/components/atoms/FlatButton.vue'
import { ref } from 'vue'
import { defineResponseHandlers } from '@/libs/utilities/graphql'
import {
  useIssueLoginLinkWithIdGenerationMutation,
  type IssueLoginLinkWithIdGenerationMutation,
} from './OkanekoId.generated'
import { useAlert } from '@/libs/alertPortal'

const { mutate: mutateForIdGeneration } =
  useIssueLoginLinkWithIdGenerationMutation()

const alert = useAlert()
const generateSize = ref(0)

const submit = async () => {
  const res = await mutateForIdGeneration({
    input: {
      size: generateSize.value,
    },
  })

  if (res?.errors && res.errors.length > 0) {
    alert.error('エラーが発生しました')
  }

  if (!res?.data) {
    return
  }

  defineResponseHandlers<
    IssueLoginLinkWithIdGenerationMutation['issueLoginLinkWithIDGeneration'],
    void
  >({
    IssueLoginLinkURLWithIDGenerationErrorProviderNotFoundPayload: () => {
      alert.error('権限がありません')
    },
    IssueLoginLinkURLWithIDGenerationSuccessPayload: payload => {
      const link = document.createElement('a')
      link.href = URL.createObjectURL(
        new Blob([payload.csv], { type: 'text/csv' })
      )
      link.download = 'ログインURL.csv'
      link.click()
    },
  })(res.data.issueLoginLinkWithIDGeneration)
}
</script>

<template>
  <section>
    <div><DolphinTextInput type="number" v-model="generateSize" /> 人分</div>
    <FlatButton
      :class="$style.submit"
      variant="primary"
      size="medium"
      :disabled="generateSize === 0"
      @click="submit"
    >
      URLを取得
    </FlatButton>
  </section>
</template>

<style module lang="scss">
.submit {
  margin-top: 24px;
}
</style>
